// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AddProductButton-module-addProductButtonWrapper-1IAVh{position:relative;padding-inline:0}.AddProductButton-module-addProductButtonLoader-3Dl3a{height:45px}.AddProductButton-module-addProductButtonWrapperMobileContent-3rmRf{margin-block-start:12px}.AddProductButton-module-mobileViewPrice-19RGc{font-size:14px;font-weight:var(--weight-medium);letter-spacing:1.5px;line-height:20px}.AddProductButton-module-button-3yyHr{width:100%}@media(min-width: 960px){.AddProductButton-module-button-3yyHr{width:auto}}", ""]);
// Exports
exports.locals = {
	"addProductButtonWrapper": "AddProductButton-module-addProductButtonWrapper-1IAVh",
	"addProductButtonLoader": "AddProductButton-module-addProductButtonLoader-3Dl3a",
	"addProductButtonWrapperMobileContent": "AddProductButton-module-addProductButtonWrapperMobileContent-3rmRf",
	"mobileViewPrice": "AddProductButton-module-mobileViewPrice-19RGc",
	"button": "AddProductButton-module-button-3yyHr"
};
module.exports = exports;
